// @flow
import eshopOrderClick                   from 'fg-frontend/webActions/eshopOrderClick';
import eshopComparisonShowDifferentLines from 'fg-frontend/webActions/eshopComparisonShowDifferentLines';
import eshopUserToolsRefresh             from './webActions/eshopUserToolsRefresh';

export default (action) => {
  switch (action) {
    case 'eshopUserToolsRefresh':
      return eshopUserToolsRefresh;
    case 'eshopOrderClick':
      return eshopOrderClick;
    case 'eshopComparisonShowDifferentLines':
      return eshopComparisonShowDifferentLines;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopActions.js